import { Enumeration } from '../../../utils/AppEnum';

export class Platform extends Enumeration<Platform> {

	public static Azure = new Platform('Azure', 0);

	public static AWS = new Platform('AWS', 1);

	public static GCP = new Platform('GCP', 2);
	
}
